export const translations = {
  novoCustumer: {
    pt: 'Novo customer segmentation',
    en: 'New customer segmentation',
    de: 'Neue Kundensegmentierung',
    es: 'Nueva segmentación de clientes',
  },
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  segmentacao: {
    pt: 'Customer segmentation',
    en: 'Customer segmentation',
    de: 'Kundensegmentierung',
    es: 'Segmentación de clientes',
  },
};